import React, { PureComponent, PropTypes } from 'react';
import { getMovementVector, isEnter } from '../../services/InputManager';
import Suggestion from './suggestion';

class LanguageSelector extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {
            selectedRow: -1
        };
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }
    onChange({ target }) {
        this.props.onChange(target.value);
        this.setState({ selectedRow: -1 });
    }
    onSelect(text) {
        this.props.onChange(text, false);
        this.setState({ selectedRow: -1 });
    }
    onKeyDown(evt) {
        let { suggestions } = this.props;
        let { selectedRow } = this.state;

        if (isEnter(evt)) {
            if (selectedRow > -1) return this.onSelect(suggestions[selectedRow]);
        }

        let [, y] = getMovementVector(evt);
        if (y !== 0) {
            selectedRow = Math.min(Math.max(0, selectedRow + y), suggestions.length - 1);
            this.setState({ selectedRow });
        }
    }
    render() {
        let { className, placeholder, suggestions, value } = this.props;
        let { selectedRow } = this.state;

        let list = suggestions.map((text, index) => <Suggestion key={text} text={text} onSelect={ () => this.onSelect(text) } selected={ selectedRow === index } />);

        return (<div className={ `autocomplete ${ className }` }>
            <input value={ value || '' } placeholder={ placeholder } onChange={ this.onChange } onKeyDown={ this.onKeyDown } autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck={false} />
            { list ? <div className="suggestions">{list}</div> : null }
        </div>);
    }
}

LanguageSelector.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    suggestions: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string.isRequired
};
LanguageSelector.defaultProps = {
    className: '',
    placeholder: '',
    suggestions: [],
    value: ''
};

export default LanguageSelector;


// WEBPACK FOOTER //
// ./src/components/autocomplete/index.js